export default [
  {
    id: 1,
    title: 'Developer',
    text: 'Test the basics of our API with limited free access.',
    call_limits: {
      calls: '10',
      stories: '100',
    },
    price: 'Free',
    button: false,
  },
  {
    id: 2,
    title: 'Business Starter',
    text: 'Basic filters, search, and archives up to 30 days with no delay',
    call_limits: {
      calls: '25K',
      stories: '100',
    },
    price: '$240',
    button: false,
  },
  {
    id: 3,
    title: 'Starter Plus',
    text: 'Fundamental and proprietary CityFALCON analytics',
    call_limits: {
      calls: '200K',
      stories: '100',
    },
    price: '$520',
    button: false,
  },
  {
    id: 4,
    title: 'Scale Up',
    text: 'Longer archives for better research',
    call_limits: {
      calls: '500K',
      stories: '200',
    },
    price: '$960',
    button: false,
  },
  {
    id: 5,
    title: 'Premium Scale Up',
    text: 'Trends, NLP tags, and sentiment analysis',
    call_limits: {
      calls: '1M',
      stories: '500',
    },
    price: '$3200',
    button: false,
  },
  {
    id: 6,
    title: 'Enterprise',
    text: 'Twitter streams and CityFALCON Advanced Analytics',
    call_limits: {
      calls: 'unlimited',
      stories: '1K',
    },
    price: '',
    button: true,
  },
];
